<template>
    <div class="container"  v-title="'用户协议'">
        <Navigation-bar id="navigation_bar" type="dark"></Navigation-bar>
        <div class="container_content">
            <div class="title">
                <h2>用户协议</h2>
                <YD-image class="logo" src="logo_新"></YD-image>
                <p class="subTitle">亿动体育用户服务协议</p>
            </div>
            <div id="UserAgreement">
                <div class="UserAgreement_content" v-html="contentHtml">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { get } from '@/api/htmlRequest'
export default {
    name: 'UserAgreement',
    data() {
        return {
            contentHtml: ''
        }
    },
    created(){
        get(process.env.VUE_APP_PUBLIC_URL + '/html/用户协议/index.html').then(data=>{
            this.contentHtml = data;
        })
    }
};
</script>
<style lang="scss" scoped>
.title{
    height: 198px;
    padding: 24px 40px 0;
    box-sizing: border-box;
    background: #1B1C1E;
    position: relative;
    h2{
        @include line-height(84px);
        font-size: 60px;
        color: #FFFFFF;
        font-weight: 500;
    }
    .logo{
        width: 106px;
        height: 56px;
        position:absolute;
        right: 40px;
        top: 38px;
    }
    p{
        @include line-height(44px);
        font-size: 32px;
        color: #43C8D9;
        font-weight: 400;
        margin-top: 6px;
    }
}
#UserAgreement{
    .UserAgreement_content{
        padding: 40px;
        box-sizing: border-box;
    }
}
</style>
<style lang="scss">
#UserAgreement{
    .UserAgreement_content{
        p{
            min-height: 28px;
            font-size: 28px;
            color: #4D5561;
            text-align: justify;
            line-height: 44px;
            font-weight: 400;
            b{
                list-style: none;
                font-size: 28px;
                color: #1B1C1E;
                text-align: justify;
                line-height: 44px;
                font-weight: 600;
            }
        }
        p[t1]{
            color: #1B1C1E;
            font-weight: 600;
            font-size: 38px;
            line-height: 52px;
            margin-bottom: 16px;
        }
        p[t1]+p{
            margin-bottom: 56px;
        }
        p[t2]{
            color: #1B1C1E;
            font-weight: 600;
            font-size: 32px;
            margin-bottom: 40px;
            margin-left: -18px;
        }
        p[t3]{
            color: #1B1C1E;
            font-weight: 600;
            font-size: 30px;
            margin-bottom: 24px;
            margin-top: 32px;
        }
    }
}
</style>